import React from "react";
import { useFormatCurrency } from "../common/format-currency";
import styles from "./cart.module.scss";

const CartSummary = ({ bundles, currency }) => {
  const { formatCurrency } = useFormatCurrency();
  const ticketItems = bundles.filter((bundle) => bundle.cartQuantity > 0);
  const totalAmount = ticketItems.reduce(
    (acc, bundle) => acc + bundle.cartQuantity * bundle.amount,
    0,
  );

  if (ticketItems.length === 0) {
    return (
      <div className={styles.cartSummary}>
        <div className={styles.emptyCartMessage}>Your cart is empty.</div>
      </div>
    );
  }

  return (
    <div className={styles.cartSummary}>
      <h2>Order Summary</h2>
      <div className={styles.summaryItems}>
        {ticketItems.map((bundle) => (
          <div key={bundle.id} className={styles.summaryItem}>
            <span className={styles.summaryItemQuantity}>
              {bundle.cartQuantity} x
            </span>
            <span className={styles.summaryItemName}>{bundle.name}</span>
            <span className={styles.summaryItemPrice}>
              {formatCurrency(bundle.amount, currency)}
            </span>
          </div>
        ))}
      </div>
      <div className={styles.summaryTotal}>
        <span>Total:</span>
        <span>{formatCurrency(totalAmount, currency)}</span>
      </div>
    </div>
  );
};

export default CartSummary;
